import React, {useEffect, useMemo, useState} from "react";
import {useParams} from "react-router-dom";
import useTranslation from "../i18n/useTranslation";

const IOS_STORE_URL = "https://apps.apple.com/app/id6743017131";
const ANDROID_STORE_URL = "https://play.google.com/store/apps/details?id=com.alejandromf27.kbolasportsmobile";

export default function ListingRedirect() {
    const {listingSlug} = useParams();
    const {t} = useTranslation();
    const [handoffAttempted, setHandoffAttempted] = useState(false);
    const listingId = useMemo(() => String(listingSlug || "").match(/-(\d+)$/)?.[1], [listingSlug]);
    const appLink = listingId ? `kbolasport://?type=listing&listingId=${listingId}` : "kbolasport://";

    useEffect(() => {
        if (!listingId) return undefined;
        window.location.href = appLink;
        const timeout = window.setTimeout(() => setHandoffAttempted(true), 1200);
        return () => window.clearTimeout(timeout);
    }, [appLink, listingId]);

    return <div style={styles.container}>
        <div style={styles.card}>
            <img src="/dist/img/angeonx-sports.png" alt="AngeonX Sports" className="logo img-fluid" style={styles.logo}/>
            <h1>{t("marketplaceRedirect.title", {}, "Open this listing in AngeonX Sports")}</h1>
            <p>{t("marketplaceRedirect.description", {}, "Continue in the AngeonX Sports mobile app to view this marketplace listing.")}</p>
            {listingId ? <a href={appLink} style={styles.primaryButton}>{t("marketplaceRedirect.openApp", {}, "Open in the app")}</a> : <p style={styles.error}>{t("marketplaceRedirect.invalid", {}, "This listing link is not valid.")}</p>}
            {handoffAttempted ? <div style={styles.fallback}>
                <span>{t("marketplaceRedirect.noApp", {}, "If the app did not open, install it here:")}</span>
                <div style={styles.storeLinks}><a href={IOS_STORE_URL}>{t("marketplaceRedirect.ios", {}, "iPhone / iPad")}</a><a href={ANDROID_STORE_URL}>{t("marketplaceRedirect.android", {}, "Android")}</a></div>
            </div> : null}
        </div>
    </div>;
}

const styles = {
    container: {minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, background: "#f7f9fc", fontFamily: "Poppins, sans-serif"},
    card: {width: "min(440px, 100%)", padding: "38px 30px", border: "1px solid #e1e7ef", borderRadius: 18, background: "#fff", boxShadow: "0 18px 44px rgba(17,24,39,.10)", textAlign: "center"},
    logo: {height: "112px", marginBottom: 16},
    primaryButton: {display: "inline-block", marginTop: 10, padding: "11px 17px", borderRadius: 11, background: "#00adff", color: "#fff", fontWeight: 800, textDecoration: "none"},
    fallback: {marginTop: 24, paddingTop: 18, borderTop: "1px solid #edf1f5", color: "#667085", fontSize: 13},
    storeLinks: {display: "flex", justifyContent: "center", gap: 18, marginTop: 10},
    error: {color: "#b42318", fontWeight: 700},
};
